/// <reference types="vite/client" />
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet, useLocation } from "@tanstack/react-router";
import { useEffect } from "react";
import "~/lib/openpanel";

import { BRAND } from "~/brand";
import { CrispChat } from "~/components/CrispChat";
import { Toaster } from "~/components/ui/sonner";
import { useIdentify } from "~/hooks/use-identify";
import { useSupportViewGate } from "~/hooks/use-support-view-gate";
import { loadAwinMasterTag } from "~/lib/awin";
import { isSupportViewActive } from "~/lib/impersonation";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootComponent,
});

function RootComponent() {
  const location = useLocation();
  useSupportViewGate();
  // Ties OpenPanel events to a profile once a real user is signed in.
  useIdentify();
  // Awin's tracking checker requires the MasterTag sitewide, not just on the
  // conversion page; it no-ops until marketing consent is granted.
  useEffect(() => {
    loadAwinMasterTag();
  }, []);
  // Same reasoning as ~/lib/openpanel: keep third-party chat off the
  // token-bearing phone-scan route too. Support views skip Crisp as well.
  const isProofRoute = location.pathname.startsWith("/laadpaal-locatie/");
  const hideThirdParty = isProofRoute || isSupportViewActive();

  return (
    <>
      <Outlet />
      {!hideThirdParty && BRAND.chat && <CrispChat />}
      <Toaster richColors position="top-center" />
      {/* <TanStackDevtools
                plugins={[
                    {
                        name: "TanStack Query",
                        render: <ReactQueryDevtoolsPanel />,
                    },
                    {
                        name: "TanStack Router",
                        render: <TanStackRouterDevtoolsPanel />,
                    },
                ]}
            /> */}
    </>
  );
}
